/*
 * @Descripttion:
 * @version:
 * @Author: suiyue
 * @email: 1373842098@qq.com
 * @Date: 2022-05-05 17:44:51
 * @LastEditors: linxi
 * @LastEditTime: 2025-06-23 20:09:05
 */
/* eslint-disable react/prop-types */
import { CaretDownFilled, SearchOutlined } from '@ant-design/icons'
import { Button, Col, Form, Input, Row, Select, Space } from 'antd'
import React, { ReactElement, useEffect } from 'react'
import { MedicalListBody } from '../../../services/commodity'
import { directoryCategoryList, getBillingCategoryCode } from '../../../models/insuranceDirectory'
import { getShopGoodsNo } from '../commoditySlice'
import { getCommonCodeCompletions } from '../../completion/completionSlice'
import { CommonCodeCategory } from '../../../models/commoncode'
import { FilterColumn } from '../../../compnents/filterForm/filterForm'
const { Item } = Form
const { Option } = Select

export interface MedicalQueryProps {
  isSPGL?: any
  filterColumn?: any
  filterSelectList?: any
  BillingCategory: any
  KeyWorld: MedicalListBody
  ProdentpNameKeyWorld?: any
  TransitionScale?: any
  Aprvno?: any
  refresh?: boolean
  submitPageList?: (selectedColumns: string[]) => void
  onValueChange: (queries: MedicalListBody) => void
  isTreatmentCatalog?: boolean
}

export const MedicalQuery: React.FC<MedicalQueryProps> = ({
  isSPGL,
  filterColumn,
  filterSelectList,
  BillingCategory,
  KeyWorld,
  ProdentpNameKeyWorld,
  TransitionScale,
  Aprvno,
  refresh,
  submitPageList,
  onValueChange,
  isTreatmentCatalog
}): ReactElement => {
  const [form] = Form.useForm()

  useEffect(() => {
    if (refresh) {
      form.resetFields()
      form.setFieldsValue({
        itemNameKeyWorld: KeyWorld,
        billingCategory: getBillingCategoryCode(BillingCategory),
        prodentpNameKeyWorld: ProdentpNameKeyWorld,
        prodConvrat: TransitionScale,
        aprvno: Aprvno
      })
    }
  }, [refresh])

  useEffect(() => {
    // form.resetFields()
    form.setFieldsValue({
      itemNameKeyWorld: KeyWorld,
      billingCategory: getBillingCategoryCode(BillingCategory),
      prodentpNameKeyWorld: ProdentpNameKeyWorld,
      prodConvrat: TransitionScale,
      aprvno: Aprvno
    })
  }, [KeyWorld])

  return (
    <Form
      form={form}
      onFinish={(vs) => {
        onValueChange(vs)
      }}
    >
      <Row style={{ height: '42px', display: 'flex', justifyContent: 'space-between' }}>
        <Space>
          <Form.Item name='itemNameKeyWorld' noStyle>
            <Input
              style={{ width: '11rem' }}
              size='middle'
              placeholder='搜索商品名称关键词'
              allowClear
            />
          </Form.Item>
          <Form.Item name='prodentpNameKeyWorld' noStyle>
            <Input style={{ width: '11rem' }} placeholder='搜索商品厂家关键字' allowClear />
          </Form.Item>
          <Form.Item name='hilistCode' noStyle>
            <Input style={{ width: '8rem' }} placeholder='搜索医保编码' allowClear />
          </Form.Item>
          <Form.Item name='aprvno' noStyle>
            <Input style={{ width: '8rem' }} placeholder='搜索批准文号' allowClear />
          </Form.Item>
          <Form.Item name='billingCategory' noStyle>
            {/* <Select placeholder='请选择类别' onChange={form.submit}>
              {directoryCategoryList.map((item) => (
                <Select.Option value={item} key={item}>
                  {getRecipeCategoryName(item)}
                </Select.Option>
              ))}
            </Select> */}
            <Select style={{ width: '8rem' }} placeholder='类别' onChange={form.submit} disabled={isTreatmentCatalog} >
              {directoryCategoryList.map((item) => (
                <Select.Option value={item.value} key={item.value}>
                  {item.label}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item name='prodConvrat' noStyle>
            <Input style={{ width: '7rem' }} placeholder='输入转换比' allowClear />
          </Form.Item>
          {form.getFieldValue('billingCategory') == "17" && <>
            <Form.Item name='spec' noStyle>
              <Input
                style={{ width: '10rem' }}
                size='middle'
                placeholder='搜索商品规格关键词'
              />
            </Form.Item>
            <Form.Item name='specMol' noStyle>
              <Input style={{ width: '11rem' }} placeholder='搜索商品型号关键字' allowClear />
            </Form.Item>
          </>}
          <Button htmlType='submit' type='primary' style={{ float: 'right' }}>
            查询
          </Button>
          <FilterColumn
            showLeft={!isSPGL}
            filterColumn={filterColumn}
            filterSelectList={filterSelectList}
            // 筛选列变化时的数据
            onColumnVisibilityChange={(v: any) => {
              // 以 filterColumn 的顺序为基准，用 v 中的字段顺序重排，并保留 filterColumn 的 visible 状态
              const sortList = filterColumn?.map((val: any) => {
                return {
                  ...val,
                  visible: v?.includes(val.field)
                }
              })
              submitPageList && submitPageList(sortList)
            }}
          />
        </Space>
      </Row>
    </Form>
  )
}
